import { Text, Box, Heading, Button, Stack, SimpleGrid, useBreakpointValue, Image } from "@chakra-ui/react";
import { FaWrench } from "react-icons/fa6";
import { BiLogoDocker, BiLogoGithub, BiServer } from "react-icons/bi";
import { FeatureCircle } from "../components/FeatureCircle";
import { MdMailOutline } from "react-icons/md";
import { useColorModeValue } from "../../../components/ui/color-mode";
import Logo from "../../../assets/logo.png";

const HeroSection = () => {
    const email = "contact@labchron.com";
    const boxWith = useBreakpointValue({ base: "95%", sm: "90%", xl: "60%" });
    const subtitleColor = useColorModeValue("gray.600", "gray.400");
    const gradientFrom = useColorModeValue("primary.600", "primary.400");
    const gradientTo = useColorModeValue("accent.500", "secondary.400");
    const circleBg = useColorModeValue("primary.50", "primary.800");
    const logoBg = useColorModeValue("white", "white");

    return (
        <Box p={{ base: 10, sm: 5 }} borderRadius="xl" width={boxWith} mx="auto" rounded="lg">
            <Stack direction="column" gap={6} alignItems="center">
                <Image
                    src={Logo}
                    alt="LabChron Logo"
                    width={{ base: "100%", sm: "70%", md: "50%", lg: "30%", xl: "30%" }}
                    borderRadius="4xl"
                    bg={logoBg}
                    p="2px"
                />
                <Heading fontSize={{ base: "2xl", sm: "3xl" }} fontWeight="bold" textAlign="center">
                    Our mission
                </Heading>
                <Heading
                    fontSize={{ base: "4xl", sm: "5xl", md: "6xl" }}
                    fontWeight="extrabold"
                    textAlign="center"
                    lineHeight="1.1"
                    bgGradient="to-r"
                    gradientFrom={gradientFrom}
                    gradientTo={gradientTo}
                    bgClip="text"
                >
                    Unlock open science
                </Heading>
                <Text
                    fontSize={{ base: "lg", md: "xl" }}
                    textAlign="center"
                    color={subtitleColor}
                    width={{ base: "100%", xl: "70%" }}
                    lineHeight="1.7"
                >
                    LabChron is an open-source platform that gives smaller bioprocess laboratories and research groups the power of modern
                    experiment monitoring. Collect sensor data in real-time, manage processes from anywhere, and own every line of code that runs your
                    lab.
                </Text>
                <Box bg={circleBg} borderRadius="2xl" px={{ base: 4, md: 10 }} py={8} width="100%">
                    <SimpleGrid columns={{ base: 2, md: 4 }} gap={{ base: 6, md: 10 }} justifyItems="center">
                        <FeatureCircle
                            title="Open standards"
                            description="Public APIs & open protocols"
                            icon={BiLogoGithub}
                            colorScheme="primary.500"
                            isComingSoon={false}
                        />
                        <FeatureCircle
                            title="Build & repair yourself"
                            description="Extend or fix anything"
                            icon={FaWrench}
                            colorScheme="primary.500"
                            isComingSoon={false}
                        />
                        <FeatureCircle
                            title="Runs on your hardware"
                            description="Deploy on-premise, your data stays yours"
                            icon={BiLogoDocker}
                            colorScheme="primary.500"
                            isComingSoon={false}
                        />
                        <FeatureCircle
                            title="Runs on LabChron cloud"
                            description="We handle ops so you focus on science"
                            icon={BiServer}
                            colorScheme="primary.500"
                        />
                    </SimpleGrid>
                </Box>
                <Stack direction={{ base: "column", sm: "row" }} gap={4}>
                    <Button colorPalette="blue" size="lg" asChild>
                        <a href="https://www.labchron.app/login">Get started</a>
                    </Button>
                    <Button variant="outline" colorPalette="blue" size="lg" asChild>
                        <a href={"mailto:" + email}>
                            <MdMailOutline /> Contact us
                        </a>
                    </Button>
                </Stack>
            </Stack>
        </Box>
    );
};

export default HeroSection;
